export const ONE = BigInt(1);
export const TEN = BigInt(10);
export const ONE_HUNDRED = BigInt(100);
export const ZERO = BigInt(0);
